interface Address {
  street: string
  zip: string
  city: string
}

export function getAddress(chancellery: { address: Address }): string {
  return `${chancellery.address.street}, ${chancellery.address.zip} ${chancellery.address.city}`.trim()
}
